// extracted by mini-css-extract-plugin
export default {"page":"forgot-password-page_page__sYtF3","text":"forgot-password-page_text__tSsqM"};